<template>
  <!-- 업체물품 반입 신청 안내 -->
  <div>
    <v-card class="ma-4 word_keeper">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-monitor-eye</v-icon>업체물품 반입 신청 안내
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          업체물품(자입자재/전산기기) 반입신청은 이렇게 하세요.
        </v-card-subtitle>
      </v-toolbar>
      <v-card-subtitle class="pt-2 pb-2 text-caption grey--text text-justify text--darken-2 font-weight-bold">
        <div class="mb-1 d-flex">1.&nbsp;<div>업체물품: 협력사가 계약이행을 위해 {{$store.state.CustomInfo.SiteNm}}에 반입하여 협력사 관리하에 휴대 및 사용 후 반출하는 지입자재(물품이나 자대 등) 또는 전산기기</div></div>
        <div class="mb-1 d-flex">2.&nbsp;<div>업체물품중 지입자재 물품은 반입일이 상이할 경우 각각 따로 입력하여 신청해주시기를 바랍니다. (부분 반입 불가)</div></div>
        <div class="mb-1 d-flex">3.&nbsp;<div>USB, CD류,프린트기는 반입불가 합니다.</div></div>
        <div class="mb-1 d-flex">4.&nbsp;<div>업체물품(지입자재/전산기기)으로 반입되는 물품은 대금정산 처리되지 않습니다. 협력사 분들은 인지해 주시기를 바랍니다.</div></div>
        <div class="mb-1 d-flex">5.&nbsp;<div>정상적으로 반입처리 된 물품에 한해서만 반출 처리가 가능합니다.</div></div>
      </v-card-subtitle>
      <v-divider class="mr-4 ml-4"></v-divider>

      <div class="flex-wrap d-flex justify-center mt-10 mb-4">     
        <img src="../assets/SKST/Guide/guide_3_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_2.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_4.svg" style="height:200px; border-radius: 10px;"/>
      </div>


      <v-card-text align="center">
        <v-divider class="mb-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" width="100px" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="$router.push({name: 'CorCarryReq'});" width="100" dark class="ml-2"><v-icon class="mr-2">mdi-open-in-new</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
  }),
  computed: {  
  },
  created() {
  },
  mounted() {
  },

  methods : {
  }
}
</script>